export default __webpack_public_path__ + "images/multilang-intro-step-2_2x.c33d73a6d565ed51f88819883f339919.png";